import auth from './middleware/auth'
import Expense from '@/screens/expenses'
import store from '@/store'
import InvoiceBox from '@/screens/expenses/InvoiceBox'
import PaymentOrders from '@/screens/expenses/PaymentOrders'
import BankReconciliation from '@/screens/expenses/BankReconciliation'
import OtherMovements from '@/screens/expenses/OtherMovements'

const routes = [
  {
    path: '/expense',
    name: 'Expense',
    component: {
      ...Expense,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Expense') {
          const routes = {
            manager: 'InvoiceBox'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Expense') {
          const routes = {
            manager: 'InvoiceBox'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'invoice-box',
        name: 'InvoiceBox',
        component: InvoiceBox,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'payment-orders',
        name: 'Payment',
        component: PaymentOrders,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'conciliation',
        name: 'Conciliation',
        component: BankReconciliation,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'other-movements',
        name: 'OtherMovements',
        component: OtherMovements,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
